<template>
	<details class="c-mcp-query-list" :open="!collapsed">
		<summary>Try these queries once connected</summary>
		<div class="c-mcp-query-list__content">
			<p>Use natural prompts to explore and organize your Swipekit data in chat.</p>
			<ul>
				<li>Show my active Meta video ads so I can review fresh creative direction.</li>
				<li>Open ad ID <code>&lt;ad-id&gt;</code> and summarize the core hook, offer, and CTA.</li>
				<li>List my boards and folders so I can audit how this workspace is organized.</li>
				<li>Show which brands I am currently tracking and which ones need coverage.</li>
				<li>Create a new board called "Winning UGC Hooks" in my default folder.</li>
				<li>Save multiplayer block ID <code>&lt;block-id&gt;</code> into board ID <code>&lt;board-id&gt;</code>.</li>
				<li>Save this ad to my Swipekit library: <code>&lt;ad-url&gt;</code>.</li>
				<li>Save this ad from <code>&lt;ad-url&gt;</code> to my "Winning UGC Hooks" board.</li>
				<li>Save this ad from <code>&lt;ad-url&gt;</code> to my "Winning UGC Hooks" board, then tag it "UGC", "Strong Hook", and "Competitor".</li>
				<li>Update ad ID <code>&lt;ad-id&gt;</code> with tags "UGC, Hook Test" and move it to board ID <code>&lt;board-id&gt;</code>.</li>
				<li>Browse multiplayer for active image ads on Facebook with query "hismile".</li>
				<li>Give me a quick usage snapshot so I can track limits and current consumption.</li>
				<li>Show my latest AI generations and suggest which ones are worth turning into tests.</li>
			</ul>
		</div>
	</details>
</template>

<script>
export default {
	name: 'McpQueryList',
	props: {
		collapsed: {
			type: Boolean,
			default: true,
		},
	},
};
</script>

<style lang="scss">
.c-mcp-query-list {
	margin: var(--spacer-sm) 0;
	border: 1px solid var(--color-bg-5);
	border-radius: 0.5rem;
	background-color: var(--color-bg-1);

	summary {
		padding: var(--margin-lg);
		font-weight: 600;
		cursor: pointer;
	}

	&__content {
		padding: 0 var(--margin-lg) var(--margin-lg);
	}

	p {
		font-size: var(--font-size-sm);
	}

	ul {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	li {
		padding: var(--margin) 0;
		font-size: var(--font-size-sm);

		&:before {
			content: none;
		}

		& + li {
			border-top: 1px solid var(--color-bg-5);
		}
	}
}
</style>
